import {AbsenceSearchRequest} from './AbsenceSearchRequest';


export class AbsenceReportRequest {
    
    absenceSearch : AbsenceSearchRequest  ;
    absenceTabType : string ;
    
    constructor(absenceSearch: any, absenceTabType: any) {
        this.absenceSearch = absenceSearch;
        this.absenceTabType = absenceTabType;
    }
}

export class AbsenceReportDto {
    Durum: string;
    Adi: string;
    Soyad: string;
    Departman: string;
    Izin_Turu: string;
    Izin_Suresi: number ;
    Tatil_Gunu: number ;
    Baslangic_Tarihi: string;
    Bitis_Tarihi: string;
    Aciklama: string;
}

export class AbsenceReportResponse {
    sheet1: AbsenceReportDto[];
    sheetNames: string[];
    workBookName: string;
}